var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackToChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18.334 15.325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18 15.09L.238 8.231q-.027-.027-.051-.056l-.01-.012-.009-.011-.008-.01v-.006l-.007-.01v-.007L.147 8.11l-.005-.008v-.007l-.006-.01v-.006l-.035-.022-.008-.015a.8.8 0 01.161-.957L7.18.242a.82.82 0 011.15 0 .8.8 0 010 1.137L2.777 6.857h14.744a.804.804 0 110 1.607H2.777l5.554 5.493a.8.8 0 010 1.137.821.821 0 01-1.15 0z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToChat);
export default __webpack_public_path__ + "static/media/backToChat.2ea3657a3f5986951fd7102d084881f5.svg";
export { ForwardRef as ReactComponent };